import { render, staticRenderFns } from "./CompleteLimitTransaction.vue?vue&type=template&id=29b97ad6&"
import script from "./CompleteLimitTransaction.vue?vue&type=script&lang=js&"
export * from "./CompleteLimitTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports